import ApontamentoEntidadeEvent from "@/domain/events/apontamentoEntidade.event";
import {reactive} from "vue";

class VendaEvents {
    apontamentoEvent = new ApontamentoEntidadeEvent()

    listenerVendaGravada = reactive({value: {vendaId: ''}})
    listenerVendaAlterada = reactive({value: {vendaId: ''}})

    emitVendaGravada(vendaId: string) {
        this.listenerVendaGravada.value = {vendaId: vendaId}
    }

    emitVendaAlterada(vendaId: string) {
        this.listenerVendaAlterada.value = {vendaId: vendaId}
    }
}

export default VendaEvents;